import React, { Component } from 'react';

export default function (ComposedComponent) {
  class LeaveIframe extends Component {
    constructor(props) {
      super(props);

      if (this.shouldLeaveIframe()) {
        window.top.location = window.location;
      };
    }

    shouldLeaveIframe() {
      return window.top !== window;
    }

    render() {
      if (this.shouldLeaveIframe()) return <div />;

      return <ComposedComponent {...this.props} />;
    }
  }

  return LeaveIframe;
}



// WEBPACK FOOTER //
// ./src/components/hoc/leave-iframe.js